import { ApiRequest, RequestMethod } from "../../request";

const URL = "/api/user/register";

export type RegisterRequest = {
  username?: string;
  password?: string;
};

export type RegisterResponse = {
  id?: string;
  success: boolean;
  message: string;
};

export async function register({ username, password }: RegisterRequest): Promise<RegisterResponse> {
  const apiRequest = new ApiRequest();
  apiRequest.setMethod(RequestMethod.POST);
  apiRequest.setUrl(URL);
  apiRequest.setJsonBody({ username, password });

  const response: any = await apiRequest.send();

  if (response.status === 200) {
    return {
      id: response.data?.id,
      success: true,
      message: "",
    };
  }

  return {
    success: false,
    message: response.data?.errorMessage ?? "Ошибка при регистрации",
  };
}
